import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { useEffect, useState } from 'react'
import { Labeled, useNotify, useRefresh } from 'react-admin'

import { postRequest } from '../../api/common'
import { detectEnvironment, Environment } from '../../config/config'
import { getVGSUrl } from '../../helpers/utils'
import { withDisableBackdropClick } from '../../helpers/withDisableBackdropClick'
import { hasPermission, Permissions } from '../../Permissions'

const useStyles = makeStyles({
  dialogContent: {
    textAlign: 'center',
    minWidth: '300px',
  },
  taxId: {
    background: '#E8FBFF',
    padding: '10px 30px',
    borderRadius: '5px',
    letterSpacing: '3px',
    margin: '0 auto',
    display: 'inline-block',
    fontSize: '30px',
  },
})

export const TeamTaxId = (props: any) => {
  if (props.hideHeader) {
    return (
      <>
        ***********
        <TaxIdDialog {...props}>Reveal</TaxIdDialog>
      </>
    )
  }

  return (
    <>
      <Labeled label="Tax ID">
        <>
          <Typography component="span" variant="body2">
            ***********
          </Typography>
          <TaxIdDialog {...props}>Reveal</TaxIdDialog>
        </>
      </Labeled>
    </>
  )
}

const TaxIdDialog = (props: any) => {
  const [open, setOpen] = useState(false)
  const [taxIdDecrypted, setTaxIdDecrypted] = useState(null)
  const [isEditing, setIsEditing] = useState(false)
  const canChangeTeam = hasPermission(props.permissions || [], Permissions.ChangeTeam)

  function handleClose() {
    setOpen(false)
    setTaxIdDecrypted(null)
    setIsEditing(false)
  }

  function renderButton() {
    if (props.ButtonComponent) {
      return <props.ButtonComponent onClick={() => setOpen(true)}>{props.children}</props.ButtonComponent>
    }

    return (
      <Button variant="text" color="primary" onClick={() => setOpen(true)}>
        {props.children}
      </Button>
    )
  }

  return (
    <>
      {renderButton()}
      <Dialog open={open} onClose={withDisableBackdropClick(() => setOpen(false))}>
        {isEditing && canChangeTeam ? (
          <EditTaxId {...props} handleClose={handleClose} taxIdDecrypted={taxIdDecrypted} />
        ) : (
          <ShowTaxId
            {...props}
            onLoad={setTaxIdDecrypted}
            handleClose={handleClose}
            handleEdit={() => setIsEditing(true)}
          />
        )}
      </Dialog>
    </>
  )
}

const ShowTaxId = (props: any) => {
  const { requestIsLoading } = props
  const classes = useStyles()
  const canChangeTeam = hasPermission(props.permissions || [], Permissions.ChangeTeam)

  return (
    <>
      <DialogTitle>Taxpayer ID Number</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography component="div" variant="h6" className={classes.taxId}>
          <RevealedCredentials {...props} />
        </Typography>

        <br />
        <br />

        <Box display="flex" flexDirection="column" alignItems="center">
          {canChangeTeam && (
            <Button color="secondary" onClick={props.handleEdit} disabled={requestIsLoading}>
              Edit
            </Button>
          )}
          <Button color="primary" variant="contained" onClick={props.handleClose} disabled={requestIsLoading}>
            Close
          </Button>
        </Box>
        <br />
      </DialogContent>
    </>
  )
}

const EditTaxId = (props: any) => {
  const { requestIsLoading } = props
  const [value, setValue] = useState(props.taxIdDecrypted)
  const classes = useStyles()
  const notify = useNotify()
  const refresh = useRefresh()
  const url = `${getVGSUrl()}/api/v1/console/teams/${props.record.id}/add-tax-info/`
  const withCredentials = detectEnvironment() === Environment.DEVELOPMENT ? false : true

  const handleSubmit = () => {
    const payload = {
      tax_id_encrypted: value,
    }

    postRequest(url, payload, { withCredentials }).then(() => {
      notify('Tax id changed', { type: 'success' })
      refresh()
      props.handleClose()
    })
  }

  return (
    <>
      <DialogTitle>Edit Taxpayer ID Number</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <TextField
          id="standard-full-width"
          label="Tax Id"
          placeholder="Tax Id"
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          data-private="redact"
        />
        <br />
        <br />

        <Button color="primary" variant="contained" onClick={handleSubmit} disabled={requestIsLoading}>
          Save
        </Button>
        <br />
        <br />

        <Button color="secondary" onClick={props.handleClose} disabled={requestIsLoading}>
          Cancel
        </Button>

        <br />
        <br />
      </DialogContent>
    </>
  )
}

const RevealedCredentials = ({ record, onLoad }: any) => {
  const [loading, setLoading] = useState(true)
  const [taxId, setTaxId] = useState(null)
  const url = `${getVGSUrl()}/api/v1/console/teams/${record.id}/tax-info/reveal/`
  const withCredentials = detectEnvironment() === Environment.DEVELOPMENT ? false : true

  useEffect(() => {
    postRequest(url, null, { withCredentials }).then((data) => {
      setLoading(false)
      setTaxId(data.tax_id_encrypted)
      onLoad(data.tax_id_encrypted)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) {
    return <>Loading...</>
  } else {
    return <span data-private="true">{taxId || 'No tax id found'}</span>
  }
}
export default TeamTaxId
